import { useAppStore } from '../../../../store/appStore';
import { useEffect, useState } from 'react';
import { getFlightScheduleService } from '../../../../api_services/FlightScheduleService';
import { AxiosError } from 'axios';

export const useGetAvailableDates = () => {
  const { selectedDateChangeMission } = useAppStore();

  const [availableGreenDays, setAvailableGreenDays] = useState<string[] | null>(null);
  const [availableDaysError, setAvailableDaysError] = useState<string | null>(null);

  useEffect(() => {
    const customer = selectedDateChangeMission?.mission.customer;
    const site = selectedDateChangeMission?.mission.site;
    const schedule = selectedDateChangeMission?.mission.schedule;

    if (!customer || !site || !schedule) {
      return;
    }

    getFlightScheduleService()
      .getAvailableDates(customer.id, site.id, schedule.airtableRecordId)
      .then((dates) => {
        setAvailableGreenDays(dates.available_green_dates);
      })
      .catch((error: AxiosError<{ detail?: string }>) => {
        setAvailableDaysError('Failed to get available dates: ' + (error.response?.data?.detail ?? 'Unknown error'));
      });
  }, [selectedDateChangeMission]);

  return { availableGreenDays, availableDaysError };
};
